import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { Table, Chip, Modal, when } from "./kit";
import kopyalaPano from "../../util/kopyala";

// Personel takibi: uygulamada cevrimici kaldigi sure (gun gun), panel islemleri ve yazili uyarilar.
const req = async (path, { method = "GET", body } = {}) => {
  const r = await fetch(`${baseURL}contract/${path}`, {
    method,
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

const RUTBE = { manager: "Manager", superadmin: "Super Admin", sa_assistant: "SA Asistanı", admin: "Admin" };
const saat = (dk) => (dk >= 60 ? `${Math.floor(dk / 60)} sa ${dk % 60 ? `${dk % 60} dk` : ""}` : `${dk || 0} dk`);
const gunler = (n) => {
  const out = [];
  for (let i = n - 1; i >= 0; i--) out.push(new Date(Date.now() - i * 864e5).toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" }));
  return out;
};

const StaffTrack = () => {
  const [days, setDays] = useState(14);
  const [hedef, setHedef] = useState(6); // gunluk asgari saat (gorsel isaret icin)
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uyari, setUyari] = useState(null);
  const [gorunum, setGorunum] = useState("gun");

  const load = useCallback(async () => {
    setLoading(true);
    const r = await req(`admin/staff?days=${days}`);
    if (r?.status) setList(r.list);
    setLoading(false);
  }, [days]);
  useEffect(() => {
    load();
  }, [load]);

  const g = gunler(Math.min(days, 14));

  const uyariVer = async (p) => {
    const sebep = window.prompt(`${p.name} için uyarı sebebi (sözleşme 5.6):`, "Belirlenen çalışma saatlerinde görev başında olmama");
    if (!sebep) return;
    const r = await req(`admin/staff/${p.userId}/warn`, { method: "POST", body: { reason: sebep } });
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    const n = r.count;
    const mesaj = `Sayın ${p.name},\n\nAYVO ${RUTBE[p.rank] || ""} sözleşmenizin 5.6 maddesi gereği ${n}. yazılı uyarınızdır.\nSebep: ${sebep}\n\n${n >= 2 ? "Aynı konunun tekrarı halinde sözleşmeniz derhal feshedilecektir." : "Lütfen çalışma düzeninize uyunuz."}\n\nARDU INTERACTIVE - FZCO`;
    const tel = String(p.contract?.phone || "").replace(/\D/g, "");
    if (tel && window.confirm(`Uyarı kaydedildi (${n}. uyarı). WhatsApp'ta ${p.name} kişisine gönderilsin mi?`)) {
      window.open(`https://wa.me/${tel}?text=${encodeURIComponent(mesaj)}`, "_blank");
    } else if (!tel) {
      kopyalaPano(mesaj);
      window.alert(`Uyarı kaydedildi (${n}. uyarı). Bu kişinin sözleşmesi bulunamadı (AYVO ID eşleşmedi); mesaj panoya kopyalandı.`);
    }
    load();
  };

  const uyariSil = async (w) => {
    if (!window.confirm("Bu uyarı kaydı silinsin mi?")) return;
    await req(`admin/staff/warning/${w._id}/delete`, { method: "POST" });
    setUyari(null);
    load();
  };

  if (gorunum === "ay") return <AylikKart geri={() => setGorunum("gun")} />;

  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap", fontSize: 13 }}>
        <button className="btn btn-sm btn-success" onClick={() => setGorunum("ay")}>
          Aylık performans kartı
        </button>
        <span>Dönem:</span>
        {[7, 14, 30].map((d) => (
          <button key={d} className={`btn btn-sm ${days === d ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setDays(d)}>
            Son {d} gün
          </button>
        ))}
        <span style={{ marginLeft: 12 }}>Günlük asgari:</span>
        <input type="number" value={hedef} min={1} max={16} onChange={(e) => setHedef(Number(e.target.value) || 6)} style={{ width: 60, padding: "3px 6px", border: "1px solid #E5E7EB", borderRadius: 6 }} /> saat
        <span style={{ color: "#6B7280", marginLeft: "auto" }}>Süre: uygulamada açık kaldığı zaman · İşlem: yönetim panelinde yaptığı işlem</span>
      </div>

      <Table
        loading={loading}
        head={["Görevli", ...g.map((d) => d.slice(8, 10) + "." + d.slice(5, 7)), `Toplam (${days} gün)`, "Uyarı", ""]}
        empty="Rütbeli personel yok."
        rows={list.map((p) => {
          const top = Object.values(p.days).reduce((a, x) => a + (x.act || 0), 0);
          const az = g.filter((d) => (p.days[d]?.min || 0) < hedef * 60).length;
          return (
            <tr key={p.userId}>
              <td style={{ whiteSpace: "nowrap" }}>
                <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 4, background: p.online ? "#22C55E" : "#D1D5DB", marginRight: 6 }} />
                <b>{p.name}</b>
                <div style={{ fontSize: 11, color: "#6B7280" }}>
                  {RUTBE[p.rank] || p.rank} · ID {p.uniqueID} {p.contract ? `· Sözleşme ${p.contract.no}` : "· sözleşme yok"}
                </div>
                {p.absentStreak >= 3 ? (
                  <Chip kind="bad">{p.absentStreak} gündür girmiyor · habersiz ayrılma (11.6)</Chip>
                ) : p.absentStreak >= 2 ? (
                  <Chip kind="wait">{p.absentStreak} gündür girmiyor</Chip>
                ) : null}
              </td>
              {g.map((d) => {
                const x = p.days[d] || { min: 0, act: 0 };
                const ok = x.min >= hedef * 60;
                return (
                  <td key={d} title={`${saat(x.min)} · ${x.act} işlem`} style={{ textAlign: "center", fontSize: 11, padding: "4px 2px", background: ok ? "#DCFCE7" : x.min > 0 ? "#FEF9C3" : "#FEE2E2", color: "#111827" }}>
                    {Math.round(x.min / 6) / 10}
                    {x.act ? <div style={{ fontSize: 9, color: "#4F46E5" }}>{x.act}i</div> : null}
                  </td>
                );
              })}
              <td style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                {saat(p.totalMin)}
                <div style={{ fontSize: 11, color: "#6B7280" }}>
                  {top} işlem · {az} gün eksik
                </div>
              </td>
              <td>
                {p.warnings.length === 0 ? (
                  <Chip>0</Chip>
                ) : (
                  <span style={{ cursor: "pointer" }} onClick={() => setUyari(p)}>
                    <Chip kind={p.warnings.length >= 2 ? "bad" : "wait"}>{p.warnings.length >= 2 ? `${p.warnings.length} · fesih hakkı doğdu` : `${p.warnings.length} uyarı`}</Chip>
                  </span>
                )}
              </td>
              <td>
                <button className="btn btn-outline-danger btn-sm" onClick={() => uyariVer(p)}>
                  Uyarı ver
                </button>
              </td>
            </tr>
          );
        })}
      />
      <div style={{ fontSize: 12, color: "#6B7280", marginTop: -6 }}>
        Kutulardaki sayı o günkü çevrimiçi saattir (yeşil: asgari doldu, sarı: eksik, kırmızı: hiç girmedi). Takip 16.10.2026'dan itibaren tutuluyor.
      </div>

      <Modal open={!!uyari} title={uyari ? `${uyari.name} · uyarılar` : ""} onClose={() => setUyari(null)}>
        {uyari?.warnings.map((w, i) => (
          <div key={w._id} className="d-flex" style={{ gap: 10, padding: "8px 0", borderBottom: "1px solid #eee", fontSize: 13 }}>
            <b>{uyari.warnings.length - i}.</b>
            <div style={{ flex: 1 }}>
              {w.reason}
              <div style={{ fontSize: 11, color: "#6B7280" }}>
                {when(w.at)} {w.by ? `· ${w.by}` : ""}
              </div>
            </div>
            <button className="btn btn-outline-secondary btn-sm" onClick={() => uyariSil(w)}>
              Sil
            </button>
          </div>
        ))}
      </Modal>
    </>
  );
};

// ------------------------------------------------ aylik performans karti
const AylikKart = ({ geri }) => {
  const simdi = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" }).slice(0, 7);
  const [ay, setAy] = useState(simdi);
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    req(`admin/staff/month?month=${ay}`).then((r) => {
      setD(r?.status ? r : null);
      setLoading(false);
    });
  }, [ay]);
  const usd = (n) => `${(Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 })} $`;
  const odemeAyi = (() => {
    const [y, m] = ay.split("-").map(Number);
    const t = new Date(y, m - 1 + 2, 1);
    return t.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });
  })();
  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap", fontSize: 13 }}>
        <button className="btn btn-sm btn-outline-secondary" onClick={geri}>
          ← Günlük takip
        </button>
        <span>Ay:</span>
        <input type="month" value={ay} onChange={(e) => setAy(e.target.value)} style={{ padding: "3px 6px", border: "1px solid #E5E7EB", borderRadius: 6 }} />
        <span style={{ color: "#6B7280", marginLeft: "auto" }}>
          {d ? `${d.days} gün hesaplandı` : ""} · Hesap sözleşmedeki varsayılan kurala göre (5.4 / 9.2)
        </span>
      </div>
      <Table
        loading={loading}
        head={["Görevli", "Çevrimiçi", "Devamsız / izin / eksik", "Uyarı", "Sabit ücret", "Kesinti", "Prim", `Bekletilen %20 (${odemeAyi})`, "Bu ay ödenecek"]}
        empty="Bu ay için kayıt yok."
        rows={(d?.list || []).map((p) => (
          <tr key={p.userId}>
            <td style={{ whiteSpace: "nowrap" }}>
              <b>{p.name}</b>
              <div style={{ fontSize: 11, color: "#6B7280" }}>
                {RUTBE[p.rank] || p.rank} · ID {p.uniqueID}
              </div>
              {!p.contract && <Chip kind="wait">imzalı sözleşme yok</Chip>}
              {p.contract && !p.contract.salaryUsd && !p.contract.bonusUsd && <div style={{ fontSize: 11, color: "#B45309" }}>Ücret: {p.contract.fee || "-"} (tutar girilmemiş)</div>}
            </td>
            <td style={{ fontSize: 12 }}>
              {saat(p.toplamDk)}
              <div style={{ fontSize: 11, color: "#6B7280" }}>{p.islem} işlem</div>
            </td>
            <td style={{ fontSize: 12 }}>
              {p.devamsiz} / {p.izin} / <b style={{ color: p.eksikGun ? "#DC2626" : "#16A34A" }}>{p.eksikGun}</b>
              {p.eksikGun > 3 && <div style={{ fontSize: 11, color: "#DC2626" }}>3+ gün: prim yanar</div>}
            </td>
            <td>{p.uyari ? <Chip kind={p.uyariToplam >= 2 ? "bad" : "wait"}>{p.uyari}</Chip> : "0"}</td>
            <td>{usd(p.maas)}</td>
            <td style={{ color: p.kesinti ? "#DC2626" : undefined }}>{p.kesinti ? `-${usd(p.kesinti)}` : "-"}</td>
            <td>{usd(p.primHak)}</td>
            <td style={{ color: "#6B7280" }}>{usd(p.bekletilen)}</td>
            <td>
              <b>{usd(p.odenecek)}</b>
            </td>
          </tr>
        ))}
      />
      <div style={{ fontSize: 12, color: "#6B7280", marginTop: -6 }}>
        Devamsız: asgari saatin yarısından az çevrimiçi kalınan gün. İzin: haftalık çalışma gününe göre hakkı olan boş gün. Eksik = devamsız − izin; her eksik gün sabit ücretin 1/30'u. Ayda 3'ten fazla eksik günde prim ödenmez. Primin %20'si 2 ay bekletilir.
      </div>
    </>
  );
};

export default StaffTrack;
